import { ChevronRight, Server, ShieldAlert, Crosshair, AlertTriangle, Wrench } from 'lucide-react';

const CHAIN_STEPS = [
  { key: 'asset', label: 'Systeem', icon: Server, color: 'text-blue-600 bg-blue-50 border-blue-200' },
  { key: 'vulnerability', label: 'Zwakke plek', icon: ShieldAlert, color: 'text-orange-600 bg-orange-50 border-orange-200' },
  { key: 'threat', label: 'Aanval', icon: Crosshair, color: 'text-red-600 bg-red-50 border-red-200' },
  { key: 'risk', label: 'Risico', icon: AlertTriangle, color: 'text-amber-600 bg-amber-50 border-amber-200' },
  { key: 'measure', label: 'Oplossing', icon: Wrench, color: 'text-emerald-600 bg-emerald-50 border-emerald-200' },
];

export const ChainVisual = ({ data = {}, activeStep, compact = false, testId }) => {
  return (
    <div className="flex items-center gap-1" data-testid={testId || 'chain-visual'}>
      {CHAIN_STEPS.map((step, i) => {
        const value = data[step.key];
        const isActive = activeStep === step.key;
        const hasValue = !!value;
        const Icon = step.icon;
        const [textColor, bgColor, borderColor] = step.color.split(' ');

        return (
          <div key={step.key} className="flex items-center gap-1">
            <div
              className={`flex items-center gap-1.5 px-2 py-1 rounded-md border text-[10px] font-medium transition-all ${
                isActive
                  ? `${bgColor} ${borderColor} ${textColor}`
                  : hasValue
                  ? `bg-white border-neutral-200 text-neutral-700`
                  : 'bg-neutral-50 border-neutral-100 text-neutral-300'
              }`}
              title={value || step.label}
            >
              <Icon className="h-3 w-3 shrink-0" strokeWidth={1.5} />
              {!compact && (
                <span className="truncate max-w-[80px]">{value || step.label}</span>
              )}
            </div>
            {i < CHAIN_STEPS.length - 1 && (
              <ChevronRight className="h-3 w-3 text-neutral-300 shrink-0" strokeWidth={1.5} />
            )}
          </div>
        );
      })}
    </div>
  );
};
